import { Box, Flex, HStack } from "@chakra-ui/react";

import { NavItem } from "src/layout/NavItem";

const MobileNavMenu = (props: { isOpen?: boolean; closeMenu?: () => void }) => {
  const { isOpen, closeMenu } = props;
  return (
    <Flex
      hidden={!isOpen}
      as="nav"
      direction="column"
      bg="brand.navy"
      position="fixed"
      height="calc(100vh - 4rem)"
      top="16"
      insetX="0"
      zIndex={10}
      w="full"
    >
      <Box px="4">
        <NavItem.Mobile label="Dealers" to="/dealers" closeMenu={closeMenu} />
        <NavItem.Mobile label="Staff" to="/staff" closeMenu={closeMenu} />
        <NavItem.Mobile
          label="Product Units"
          to="/product-units"
          closeMenu={closeMenu}
        />
        <NavItem.Mobile
          label="Properties"
          to="/properties"
          closeMenu={closeMenu}
        />
      </Box>
    </Flex>
  );
};

const DesktopNavMenu = () => (
  <HStack spacing="3" flex="1" display={{ base: "none", lg: "flex" }}>
    <NavItem.Desktop label="Dealers" to="/dealers" />
    <NavItem.Desktop label="Staff" to="/staff" />
    <NavItem.Desktop label="Product Units" to="/product-units" />
    <NavItem.Desktop label="Properties" to="/properties" />
  </HStack>
);

export const NavMenu = {
  Mobile: MobileNavMenu,
  Desktop: DesktopNavMenu,
};
